import { AnalyticsEventTypes } from '../types';
import createPrimitiveReducer from '~lib/shared/redux/reducers/primitive-reducer';

const sourceTrackingReducer = createPrimitiveReducer<Record<string, string>>(AnalyticsEventTypes.SOURCE_TRACKING, {});

export default sourceTrackingReducer;
